// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"WeekCarousel_titleBox__3kelk","title":"WeekCarousel_title__2Ldlg","weekContainer":"WeekCarousel_weekContainer__3re1S"};